export const ToggleInteraccionFavorita = async (id: number): Promise<any> => {
    try {
        const baseUrl = (process.env.REACT_APP_API_URL || 'http://localhost').replace(/\/$/, "");
        const res = await fetch(`${baseUrl}:8061/jutge/interaccion/${id}/favorita`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            }
        });
        
        if (!res.ok) {
            throw new Error(`Error: ${res.status}`);
        }
        
        return true;
    } catch (e) {
        console.log(e);
        return null;
    }
};
